<!-- Header Part Start-->
<div class="container-fluid" style="padding: 0px 5px;">
  <div style=" display: inline;block-size: 10%;">
   <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding: 10px;">
     <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px; ">
       <h2 class="header lblHeader newHeader" style="font-size: 25px; margin-left: 5px;">
         Task History
       </h2>
     </div>
     <!-- Search -->
     <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
       <span class="search" *ngIf="dataSource.data.length > 0">
         <span class="fa fa-search" style="padding-left: 13px; font-size: 13px; position: absolute;top: 10px;color: #999;">
         </span>
         <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
             (keyup)="applyFilter($event)" #input
             style="text-align: left; background-color: white ! important; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 29%; height: 33px !important;"
             type="text">
       </span>
     <!-- Export to Excel  -->
       <span *ngIf="dataSource.data.length > 0" (click)="exportToExcelTasks()" class="orangeButton" style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
           <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
       </span>
     <!-- Back Button (Return To Task) -->
           <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
             <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
               (click)="backBtn()">
                 <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Tasks
             </span>
           </div>
     </div>
   </div>
 <!-- Select Month(drop-down) -->
 <div class="col-md-12" style="padding: 10px; margin-top: -10px">
   <div class="col-md-6" style="padding-left: 6px; display: inline-block;">
   <!-- Select Executive(drop-down) -->
   <div class="" style="display: inline-block; margin-top: 17px; margin-left:5px;">
     <select  class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 125px;cursor: pointer;" [(ngModel)]="user.id" (change)="applyTaskStatusFilter(filterTypeID ? filterTypeID : 1)">
       <option value="0">Select Executive</option>
       <!-- <option value="{{i.UserID}}" *ngFor="let i of userList | sort : 'Name' : 0">{{i.Name}}</option>  -->
       <option *ngFor="let i of userList" value="{{i.UserID}}">{{i.Name}}</option> 
     </select>
   </div>
   <div class="" style="display:inline-block; padding: 0px;margin-left: 15px;">
     <div style="display: inline-block;">
       <label style="margin-left: 0px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
       for="sel1">Month : </label>
     </div>
     <div style="display: inline-block;margin-left: 5px;">
       <select  class="form-control bgwhite formCtlFltr " style="box-shadow: none;width: 100px;cursor: pointer;" [(ngModel)]="monthDisplay"
         (change) ="changeYrMonth()">
         <option *ngFor="let i of months;">{{i.display}}</option>
       </select>
     </div>
   </div> 
   
   <!-- Select Date -->
   <div style="display: inline-block; margin-right: -30px;margin-left: 15px;">
     <div class="checkbox font13">
         <label (change)="clickShowDate(showDate);"
             style="margin-bottom: 0px !important; margin-top: 5px; line-height: 30px; cursor: pointer;">
             <input type="checkbox"  class="chkbox-darkblue" [(ngModel)]="showDate"
                 style="margin-right: 5px;font-size: 13px; position: relative; top: 2px;">Select Date
         </label>
         <div style="display: inline-block;width: 40%; margin-left: 10px;" *ngIf="showDate == true">
 
           <div style="outline: none !important; width: 100%; display: inline-block;">
               <input matInput readonly (focus)="picker2.open()" [matDatepicker]="picker2" [min]= "minDT" [max]="maxDT" class="form-control"
                   [(ngModel)]="selectedDate" (ngModelChange)="this.applyTaskStatusFilter(this.filterTypeID ? this.filterTypeID : 1)"
                   style="display: inline-block; width: 60%; outline: none !important; cursor: pointer; background: #FFF;">
               <mat-datepicker-toggle matSuffix [for]="picker2"
                   style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
               <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
           </div>
         </div>
     </div>
   </div>
 </div>
 <div class="col-md-6 col-sm-8" style="display: inline-block; padding: 0px; text-align: right;">
  <div class="" style="display: inline-block; padding-top: 15px;">
    <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 1 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(1)" style="cursor: pointer; padding: 2px 10px;"> <span>All</span></span>
    <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 2 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(2)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Open</span></span>
    <!-- <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 3 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(3)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Closed</span></span> -->
    <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 4 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(4)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Completed on Time</span></span>
    <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 5 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(5)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"><span>Completed Late</span></span>
  </div>
</div>
</div>
 <!-- Filters -->
 <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite" style="padding-left: 6px; display: none;">
  <div class="col-md-8 col-sm-8" style="display: inline-block;padding-left: 5px;">
    <div class="" style="display: inline-block; padding-top: 15px;">
      <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 1 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(1)" style="cursor: pointer; padding: 2px 10px;"> <span>All</span></span>
      <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 2 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(2)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Open</span></span>
      <!-- <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 3 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(3)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Closed</span></span> -->
      <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 4 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(4)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"> <span>Completed on Time</span></span>
      <span class="label custom-margin-btn bz-drkBlueBtn-lb btnPad fntSz {{filterTypeID == 5 ? 'bz-drkBlueBtn-lb-active' : ''}}"(click)="applyTaskStatusFilter(5)" style="cursor: pointer; margin-left: 8px; padding: 2px 10px;"><span>Completed Late</span></span>
    </div>
  </div>
 </div>
 <!-- Table -->
 <div class="wrapper" style=" padding:0px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 5px 10px; margin-left: 10px; border-radius: 3px;"  #cstTable>
   <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;" *ngIf="dataSource.data.length > 0">
     <ng-container matColumnDef="CreatedDT">
       <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
       <label style="font-size: 13px; width: 10%;">Created on</label></th>         
       <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-left: 9px ! important;"> {{element.CreatedDT}} </td>
     </ng-container>

     <ng-container matColumnDef="Task">
      <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
      <label style="font-size: 13px;">Tasks</label></th>
      <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px ! important;vertical-align: middle; padding-left: 0px ! important; text-overflow: ellipsis; white-space: initial;"> {{element.Task}} </td>
    </ng-container>

    <ng-container matColumnDef="ToUserName">
      <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px;">
      <label style="font-size: 13px;">Executive</label></th>
      <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px ! important;vertical-align: middle;padding-left: 0px ! important;"> {{element.ToUserName}} </td>
    </ng-container>
 
     <ng-container matColumnDef="ExpCompletionDT">
       <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
       <label style="font-size: 13px; width: 10%;">Expected on</label></th>
       <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px !important;vertical-align: middle;"  > {{element.ExpCompletionDT}}  </td>
     </ng-container>
              
     <ng-container matColumnDef="DoneDT" style="display:inline-block ;">
       <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
       <label style="font-size: 13px; width: 10%;">Done on</label></th>
       <td mat-cell *matCellDef="let element" style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-right: 0px ! important;"> {{element.DoneDT ? element.DoneDT : '-'}}  </td>
     </ng-container>
 
     <ng-container matColumnDef="Priority">
       <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 10px; padding-bottom: 5px; padding-left: 7px;">
       <label style="font-size: 13px; width: 10%;"> Priority </label></th>
       <td mat-cell *matCellDef="let element" style="text-align: left; vertical-align: middle;" > {{element.Priority}}  </td>
     </ng-container>
   
     <ng-container matColumnDef="Status">
       <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 26px; width: 6%;">
       <label style="cursor: pointer;font-size: 13px;">Status</label></th>
       <td mat-cell *matCellDef="let element"> <div style="text-align: left; vertical-align: middle; margin-left: 19px;"> {{element.Status}} </div> </td>
     </ng-container>
       
       <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
       <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
 
   </table>
 <!-- Angular 8 pagination -->
 <mat-paginator style="border-radius: 0px 0px 3px 3px;" [pageSizeOptions]="[5, 10, 20]" *ngIf="dataSource.data.length > 0"></mat-paginator>
 </div>
    <div *ngIf="dataSource.data.length == 0" style="padding: 0px 20px;">
   <div class="nrf brdrRadius3">No records found.</div>
   </div> 
  </div>
 </div>
 